module.exports = __webpack_public_path__ + "static/media/bigboss parrot.0633768b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/bigboss parrot.gif
// module id = 371
// module chunks = 0